import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { DownloadButton, StoreButtons } from "./DownloadButtons";
import { APP_SCREENS } from "@/lib/leadzi";

const TABS = [
  { key: "dashboard", label: "Tableau de bord", img: APP_SCREENS.dashboard },
  { key: "newOpportunity", label: "Nouvelle opportunité", img: APP_SCREENS.newOpportunity },
  { key: "sent", label: "Opportunité envoyée", img: APP_SCREENS.sent },
  { key: "proposal", label: "Proposition Leadzi", img: APP_SCREENS.proposal },
];

export const AppShowcase = () => {
  const [active, setActive] = useState("dashboard");
  const current = TABS.find((t) => t.key === active);

  return (
    <section id="app" className="relative scroll-mt-20 overflow-hidden bg-ink py-24 lg:py-32">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute bottom-0 left-1/2 h-[500px] w-[700px] -translate-x-1/2 rounded-full bg-brand/15 blur-[130px]" />
      </div>

      <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:gap-8 lg:px-8">
        <div>
          <Overline dark>L'application</Overline>
          <h2 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1]">
            Toutes tes opportunités dans ta poche.
          </h2>
          <p className="mt-6 max-w-lg text-lg leading-relaxed text-white/55">
            Avec Leadzi CHR, tu peux déposer une opportunité directement depuis ton
            smartphone et suivre son traitement, étape par étape.
          </p>

          <div data-testid="app-screens-interactive-tabs" className="mt-8 flex flex-wrap gap-2">
            {TABS.map((t) => (
              <button
                key={t.key}
                data-testid={`app-tab-${t.key}`}
                onClick={() => setActive(t.key)}
                className={`rounded-full px-4 py-2 text-sm font-semibold transition-all duration-300 ${
                  active === t.key
                    ? "bg-brand text-white"
                    : "border border-white/15 bg-white/5 text-white/70 hover:bg-white/10"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>

          <div className="mt-9">
            <DownloadButton testId="app-section-download-cta" className="px-7 py-3.5 text-base" />
          </div>
          <div className="mt-6">
            <StoreButtons />
          </div>
        </div>

        {/* phone */}
        <div className="flex justify-center">
          <div className="relative w-full max-w-xs">
            <div className="absolute -inset-6 -z-10 rounded-[3rem] bg-brand/25 blur-3xl" />
            <div className="relative overflow-hidden rounded-[2.75rem] border-[10px] border-[#20242c] bg-[#20242c] shadow-[0_40px_90px_-20px_rgba(0,0,0,0.7)]">
              <div className="absolute left-1/2 top-0 z-10 h-6 w-32 -translate-x-1/2 rounded-b-2xl bg-[#20242c]" />
              <AnimatePresence mode="wait">
                <motion.img
                  key={active}
                  src={current.img}
                  alt={`Écran ${current.label}`}
                  initial={{ opacity: 0, scale: 1.03 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.98 }}
                  transition={{ duration: 0.35 }}
                  className="block w-full"
                />
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
